import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import {  FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { EmployerDetails } from '../../data/employer-details';
import { LookupItem } from '../../models/lookup-item';
import { AbnValidators } from '../../validators/abn-validatiors';
import { OptionItem } from '../../data/option-item';


@Component({
  selector: 'app-business-enquiry-form',
  templateUrl: './business-enquiry-form.component.html',
  styleUrl: './business-enquiry-form.component.scss'
})
export class BusinessEnquiryFormComponent implements OnInit {

  @Input()model!: InitialAssessmentForm;
  @Input() phoneTypes!: OptionItem[];
  @Output() formReady = new EventEmitter<FormGroup>();


formBuilder = inject(NonNullableFormBuilder);

  businessEnquiryForm = this.formBuilder.group({
    name: [''],
    abn: [''],
    firstname: [''],
    surname: [''],
    email: [''],
    phoneType: [null as OptionItem | null],
    phoneCountryCode: [''],
    phoneAreaCode: [''],
    phoneNumber: ['']
  });

  constructor() { }

  ngOnInit(): void {

    this.initializeForm();
    this.formReady.emit(this.businessEnquiryForm);
  }


    initializeForm() {
     
      this.model = this.model || new InitialAssessmentForm();
      this.model.employer = this.model.employer || new EmployerDetails();
  
      this.businessEnquiryForm.patchValue({
        name: this.model.employer.name || '',
        abn: this.model.employer.abn || '',
        firstname: this.model.employer.firstName || '',
        surname: this.model.employer.surname || '',
        email: this.model.employer.email || '',
        phoneType: this.model.employer.phoneType || null,
        phoneCountryCode: this.model.employer.phoneCountryCode || '',
        phoneAreaCode: this.model.employer.phoneAreaCode || '',
        phoneNumber: this.model.employer.phoneNumber || ''
      });

      this.applyValidators();

      this.businessEnquiryForm.valueChanges.subscribe(formValues => {
        this.model.employer!.name = formValues.name || '';
        this.model.employer!.abn = formValues.abn   || '';
        this.model.employer!.firstName = formValues.firstname   || '';
        this.model.employer!.surname = formValues.surname || '';
        this.model.employer!.email = formValues.email || '';
        this.model.employer!.phoneType = formValues.phoneType || null;
        this.model.employer!.phoneCountryCode = formValues.phoneCountryCode || '';
        this.model.employer!.phoneAreaCode = formValues.phoneAreaCode || '';
        this.model.employer!.phoneNumber = formValues.phoneNumber || '';
      });
    }

    applyValidators(){
        const nameControl = this.businessEnquiryForm.controls.name;
        const abnControl = this.businessEnquiryForm.controls.abn;
        const firstNameControl = this.businessEnquiryForm.controls.firstname;
        const surnameControl = this.businessEnquiryForm.controls.surname;
        const emailControl = this.businessEnquiryForm.controls.email;
        const phoneTypeControl = this.businessEnquiryForm.controls.phoneType;
        const phoneCountryCodeControl = this.businessEnquiryForm.controls.phoneCountryCode;
        const phoneAreaCodeControl = this.businessEnquiryForm.controls.phoneAreaCode;
        const phoneNumberControl = this.businessEnquiryForm.controls.phoneNumber; 
                
        nameControl.setValidators([Validators.required]);
        abnControl.setValidators([AbnValidators.maxLength()]);
        firstNameControl.setValidators([Validators.required]);
        surnameControl.setValidators([Validators.required]);
        emailControl.setValidators([Validators.required, Validators.email]);
        phoneTypeControl.setValidators([]); 
        phoneCountryCodeControl.setValidators([]); 
        phoneNumberControl.setValidators([]);
        phoneAreaCodeControl.setValidators([]);
      

        this.businessEnquiryForm.updateValueAndValidity();

    }


}
